// D:\MAHAL(UPDATED)-NEW11-04\MAHAL kdsagakhjqsdfk\src\pages\Support\Escalated.js

import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import axios from "axios";

import {
  FaExclamationTriangle,
  FaClock,
  FaUserShield,
  FaLayerGroup,
  FaSyncAlt,
  FaSearch,
  FaFilter,
  FaEye,
  FaArrowRight,
  FaBolt,
  FaHistory,
  FaUserTie,
  FaTimes
} from "react-icons/fa";

// import "./Escalated.css";
import "./Support.css";

const API =
  "https://api.mahal.qa/api/v1/admin/support";
export default function Escalated() {

  const token =
    localStorage.getItem("admin_token");

  const [loading, setLoading] =
    useState(true);

  const [tickets, setTickets] =
    useState([]);

  const [summary, setSummary] =
    useState({});

  const [selectedTicket, setSelectedTicket] =
    useState(null);

  const [ticketDetails, setTicketDetails] =
    useState(null);

  const [detailsLoading, setDetailsLoading] =
    useState(false);

  const [filters, setFilters] =
    useState({
      search: "",
      priority: "",
      queue: "",
      escalation_level: "",
      sla_breached: "",
      cooldown_active: "",
      reassigned: "",
      idle_only: ""
    });

  /* ========================================================
     FETCH ESCALATED TICKETS
  ======================================================== */

  const fetchEscalatedTickets = async () => {

    try {

      setLoading(true);

      const res = await axios.get(
        `${API}/escalated`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            ...filters,
            limit: 50
          }
        }
      );

      setTickets(res.data?.data || []);

      setSummary(res.data?.summary || {});

    } catch (err) {

      console.error(
        "Failed to load escalated tickets",
        err
      );

    } finally {

      setLoading(false);
    }
  };

  /* ========================================================
     FETCH TICKET DETAILS
  ======================================================== */

  const fetchTicketDetails = async (
    ticketId
  ) => {

    try {

      setDetailsLoading(true);

      const res = await axios.get(
        `${API}/ticket/${ticketId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setTicketDetails(res.data);

    } catch (err) {

      console.error(
        "Failed to load ticket details",
        err
      );

    } finally {

      setDetailsLoading(false);
    }
  };

  /* ========================================================
     INITIAL LOAD
  ======================================================== */

  useEffect(() => {

    fetchEscalatedTickets();

  }, [filters]);

  /* ========================================================
     SUMMARY
  ======================================================== */

  const cards = useMemo(() => [

    {
      label: "Active Escalations",
      value:
        summary.active_escalations || 0,
      icon: <FaExclamationTriangle />,
      className: "danger"
    },

    {
      label: "SLA Breaches",
      value:
        summary.sla_breaches || 0,
      icon: <FaClock />,
      className: "warning"
    },

    {
      label: "Critical Queue",
      value:
        summary.critical_queue || 0,
      icon: <FaBolt />,
      className: "critical"
    },

    {
      label: "Avg Escalation Time",
      value:
        summary.avg_escalation_time ||
        "0m",
      icon: <FaHistory />,
      className: "info"
    },

    {
      label: "Escalated Today",
      value:
        summary.escalated_today || 0,
      icon: <FaLayerGroup />,
      className: "purple"
    },

    {
      label: "Reassignments",
      value:
        summary.reassigned_count || 0,
      icon: <FaSyncAlt />,
      className: "blue"
    }

  ], [summary]);

  /* ========================================================
     OPEN MODAL
  ======================================================== */

  const openModal = async (
    ticket
  ) => {

    setSelectedTicket(ticket);

    await fetchTicketDetails(
      ticket.ticket_id
    );
  };

  /* ========================================================
     CLOSE MODAL
  ======================================================== */

  const closeModal = () => {

    setSelectedTicket(null);

    setTicketDetails(null);
  };

  /* ========================================================
     RENDER
  ======================================================== */

  return (

    <div className="support-page">

      {/* ====================================================
         HEADER
      ==================================================== */}

      <div className="support-header-content">

        <div className="support-live-tag">

          <span className="support-live-dot"></span>

          LIVE AUTOMATION ENGINE

        </div>

        <h1>Escalation Command Center</h1>
        <p>Critical operational escalation monitoring</p>

      </div>

      {/* ====================================================
         SUMMARY CARDS
      ==================================================== */}

      <div className="support-summary-grid">

        {cards.map((card, index) => (

          <div
            key={index}
            className={`support-summary-card ${card.className}`}
          >

            <div className="support-summary-icon">
              {card.icon}
            </div>

            <div>

              <h3>
                {card.value}
              </h3>

              <p>
                {card.label}
              </p>

            </div>

          </div>

        ))}

      </div>

      {/* ====================================================
         FILTERS
      ==================================================== */}

      <div className="support-filters">

        <div style={{ position: "relative" }}>



          <input
            className="support-search"
            type="text"
            placeholder="Search ticket / subject"
            value={filters.search}
            onChange={(e) =>
              setFilters({
                ...filters,
                search: e.target.value
              })
            }
          />

        </div>

        <select className="support-select"
          value={filters.priority}
          onChange={(e) =>
            setFilters({
              ...filters,
              priority: e.target.value
            })
          }
        >
          <option value="">
            All Priorities
          </option>

          <option value="low">
            Low
          </option>

          <option value="normal">
            Normal
          </option>

          <option value="high">
            High
          </option>

        </select>

        <select className="support-select"
          value={filters.sla_breached}
          onChange={(e) =>
            setFilters({
              ...filters,
              sla_breached:
                e.target.value
            })
          }
        >
          <option value="">
            SLA Status
          </option>

          <option value="true">
            Breached
          </option>

          <option value="false">
            Safe
          </option>

        </select>

        <select className="support-select"
          value={filters.escalation_level}
          onChange={(e) =>
            setFilters({
              ...filters,
              escalation_level:
                e.target.value
            })
          }
        >
          <option value="">
            Escalation Level
          </option>

          <option value="1">
            Level 1
          </option>

          <option value="2">
            Level 2
          </option>

        </select>

      </div>

      {/* ====================================================
         TABLE
      ==================================================== */}

      <div className="support-table-wrap">

        <table className="support-table">

          <thead>

            <tr>

              <th>Ticket</th>

              <th>Queue Flow</th>

              <th>Priority</th>

              <th>Escalation</th>

              <th>SLA</th>

              <th>Assigned</th>

              <th>Reason</th>

              <th>Last Activity</th>

              <th>Actions</th>

            </tr>

          </thead>

          <tbody>

            {!loading &&
              tickets.length === 0 && (

                <tr>

                  <td
                    colSpan="9"
                    className="support-empty-state"
                  >
                    No escalated tickets found
                  </td>

                </tr>

              )}

            {tickets.map((t) => (

              <tr key={t.ticket_id}>

                <td>

                  <div className="support-table-title">

                    <strong>
                      #{t.ticket_id}
                    </strong>

                    <span>
                      {t.subject}
                    </span>

                  </div>

                </td>

                <td>

                  <div className="support-table-title">

                    <span>
                      {t.queue_flow ||
                        t.queue_name}
                    </span>

                  </div>

                </td>

                <td>

                  <span
                    className={`support-priority ${t.priority}`}
                  >
                    {t.priority}
                  </span>

                </td>

                <td>

                  <div className="support-badge is-critical">
                    Level{" "}
                    {t.escalation_level}
                  </div>

                </td>

                <td>

                  <span
                    className={
                      t.sla_breached
                        ? "support-badge is-breached"
                        : "support-badge is-sla-safe"
                    }
                  >
                    {t.sla_breached
                      ? "BREACHED"
                      : "SAFE"}
                  </span>

                </td>

                <td>

                  <div className="support-user-info">

                    <FaUserTie />

                    {t.assigned_admin_name ||
                      "Unassigned"}

                  </div>

                </td>

                <td>

                  <span className="support-badge">

                    {t.escalation_reason ||
                      "Operational Escalation"}

                  </span>

                </td>

                <td>

                  {t.last_activity
                    ? new Date(
                      t.last_activity
                    ).toLocaleString()
                    : "-"}

                </td>

                <td>

                  <button
                    className="support-table-btn"
                    onClick={() =>
                      openModal(t)
                    }
                  >

                    <FaEye />

                    View

                  </button>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

      {/* ====================================================
         MODAL
      ==================================================== */}

      {selectedTicket && (

        <div className="support-modal-overlay">

          <div className="support-modal">

            {/* ================================================
               HEADER
            ================================================ */}

            <div className="support-modal-header">

              <div>

                <h2>
                  Escalated Ticket #
                  {
                    selectedTicket.ticket_id
                  }
                </h2>

                <p>
                  Operational escalation
                  review
                </p>

              </div>

              <button
                onClick={closeModal}
                className="support-modal-close"
              >
                <FaTimes />
              </button>

            </div>

            {/* ================================================
               LOADING
            ================================================ */}

            {detailsLoading && (

              <div className="support-modal-loading">
                Loading...
              </div>

            )}

            {/* ================================================
               BODY
            ================================================ */}

            {!detailsLoading &&
              ticketDetails && (

                <div className="support-modal-body">

                  {/* ==========================================
                     TOP GRID
                  ========================================== */}

                  <div className="support-modal-grid">

                    <div className="support-modal-section support-modal-col-6">

                      <h4>
                        Queue Flow
                      </h4>

                      <div className="queue_visual">

                        {selectedTicket.queue_flow ||
                          selectedTicket.queue_name}

                      </div>

                    </div>

                    <div className="support-modal-section support-modal-col-6">

                      <h4>
                        SLA Risk
                      </h4>

                      <div className="support-note">

                        <span>
                          Status:
                          {
                            selectedTicket.sla_breached
                              ? " BREACHED"
                              : " SAFE"
                          }
                        </span>

                        <span>
                          Escalation Level:
                          {" "}
                          {
                            selectedTicket.escalation_level
                          }
                        </span>

                      </div>

                    </div>

                  </div>

                  {/* ==========================================
                     ASSIGNMENT HISTORY
                  ========================================== */}

                  <div className="support-modal-section">

                    <h3>
                      Assignment Timeline
                    </h3>

                    <div className="support-timeline">

                      {ticketDetails.assignment_history?.map(
                        (item, index) => (

                          <div
                            key={index}
                            className="support-timeline-item"
                          >

                            <div className="support-timeline-dot"></div>

                            <div className="support-timeline-content">

                              <strong>
                                Assignment Updated
                              </strong>

                              <p>
                                Admin:
                                {" "}
                                {
                                  item.new_admin_id
                                }
                              </p>

                              <span>
                                {new Date(
                                  item.changed_at
                                ).toLocaleString()}
                              </span>

                            </div>

                          </div>

                        )
                      )}

                    </div>

                  </div>

                  {/* ==========================================
                     STATUS HISTORY
                  ========================================== */}

                  <div className="support-modal-section">

                    <h3>
                      Escalation Timeline
                    </h3>

                    <div className="support-timeline">

                      {ticketDetails.history?.map(
                        (item, index) => (

                          <div
                            key={index}
                            className="support-timeline-item"
                          >

                            <div className="support-timeline-dot"></div>

                            <div className="support-timeline-content">

                              <strong>
                                {
                                  item.old_status
                                }
                                {" "}
                                →
                                {" "}
                                {
                                  item.new_status
                                }
                              </strong>

                              <p>
                                {
                                  item.remark ||
                                  "Status Updated"
                                }
                              </p>

                              <span>
                                {new Date(
                                  item.changed_at
                                ).toLocaleString()}
                              </span>

                            </div>

                          </div>

                        )
                      )}

                    </div>

                  </div>

                  {/* ==========================================
                     NOTES
                  ========================================== */}

                  <div className="support-modal-section">

                    <h3>
                      Internal Notes
                    </h3>

                    <div className="support-notes">

                      {ticketDetails.notes?.length ===
                        0 ? (

                        <p className="support-empty-state">
                          No internal notes
                        </p>

                      ) : (

                        ticketDetails.notes?.map(
                          (note) => (

                            <div
                              key={note.note_id}
                              className="support-note"
                            >

                              <div className="support-note-header">

                                <strong>
                                  {
                                    note.admin_name
                                  }
                                </strong>

                                <span>
                                  {new Date(
                                    note.created_at
                                  ).toLocaleString()}
                                </span>

                              </div>

                              <p>
                                {note.note}
                              </p>

                            </div>

                          )
                        )

                      )}

                    </div>

                  </div>

                </div>

              )}

          </div>

        </div>

      )}

    </div>
  );
}